<div class="tooth-diagram-wrapper">

  <!-- Raíz arriba para Superior -->
  <div class="root-label" *ngIf="arch === 'upper'">▲ Raíz</div>

  <!-- Zonas rectangulares clicables -->
  <div class="tooth-rect">
    <div class="zone-rect"
         [class.zone-selected]="selected === zones[0]?.key"
         (click)="select(zones[0]?.key)">
      {{ zones[0]?.label }}<span *ngIf="zones[0]?.recommended"> ★</span>
    </div>
    <div class="zone-rect"
         [class.zone-selected]="selected === zones[1]?.key"
         (click)="select(zones[1]?.key)">
      {{ zones[1]?.label }}<span *ngIf="zones[1]?.recommended"> ★</span>
    </div>
    <div class="zone-rect zone-rect-last"
         [class.zone-selected]="selected === zones[2]?.key"
         (click)="select(zones[2]?.key)">
      {{ zones[2]?.label }}<span *ngIf="zones[2]?.recommended"> ★</span>
    </div>
  </div>

  <!-- Raíz abajo para Inferior -->
  <div class="root-label" *ngIf="arch === 'lower'">▼ Raíz</div>

  <p class="arch-title">Arcada {{ arch === 'lower' ? 'Inferior' : 'Superior' }}</p>
  <p class="star-legend">★ Posición recomendada</p>
</div>
